import { useEffect, useRef } from 'react';

function useSideEffects({ setMainMenu, menus, setSize, location, mainMenu }) {
	const _mainMenu = useRef(mainMenu);
	useEffect(() => {
		setMainMenu(menus);
	}, [menus]);

	useEffect(() => {
		_mainMenu.current = mainMenu;
	}, [mainMenu]);

	const updateMenusBasedOnRoute = () => {
		const updateMenuAndFirstSubMenu = (menuKey) => {
			const head = menus?.map((item, index) => {
				if (item.key === menuKey) {
					return {
						...item,
						isSelect: !item.isSelect,
						isVisible: typeof mainMenu?.[index]?.isVisible === 'boolean' ? mainMenu?.[index]?.isVisible : !item.isVisible,
						subMenus: item.subMenus
							? item.subMenus.map((subMenu, index) => {
								if (index === 0) {
									return {
										...subMenu,
										isSelect: true,
									};
								} else {
									return { ...subMenu };
								}
							})
							: [],
					};
				}
				return { ...item, isSelect: false };
			});
			setMainMenu(head);
		};
		const updateSubMenuAndParentMenu = (menuKey) => {
			const submenus = menus?.map((item, index) => {
				let menusIsSelected = false;
				let isVisible = false;
				return {
					...item,
					subMenus: item?.subMenus?.map((items) => {
						if (items.key === menuKey) {
							menusIsSelected = true;
							isVisible =
								typeof _mainMenu.current?.[index]?.isVisible === 'boolean' ? _mainMenu.current?.[index]?.isVisible : !item.isVisible;
							return { ...items, isSelect: true };
						}
						return { ...items, isSelect: false };
					}),
					isSelect: menusIsSelected,
					isVisible: isVisible,
				};
			});
			setMainMenu(submenus);
		};

		let pathName = location?.pathname;
		let locationsplit1 = pathName?.split('/');

		switch (pathName) {
			case '/': {
				updateMenuAndFirstSubMenu('dashboard');
				break;
			}
			case '/home': {
				updateMenuAndFirstSubMenu('home');
				break;
			}
			case '/employee/request_leave': {
				updateMenuAndFirstSubMenu('request-leave');
				break;
			}
			case '/run-payroll': {
				updateSubMenuAndParentMenu('run-payroll');
				break;
			}
			case '/payroll-plus': {
				updateSubMenuAndParentMenu('run-payroll');
				break;
			}
			case '/payroll/run/channel': {
				updateSubMenuAndParentMenu('run-payroll');
				break;
			}
			case '/payroll/run/channel/wps': {
				updateSubMenuAndParentMenu('run-payroll');
				break;
			}
			case '/payroll/run/channel/now_or_later': {
				updateSubMenuAndParentMenu('run-payroll');
				break;
			}
			case '/payroll/run/channel/submit_payroll': {
				updateSubMenuAndParentMenu('run-payroll');
				break;
			}
			case '/upload/salary/spreadsheet_or_sif': {
				updateSubMenuAndParentMenu('run-payroll');
				break;
			}
			case '/payroll/run/channel/next_steps': {
				updateSubMenuAndParentMenu('run-payroll');
				break;
			}
			case '/payroll/history': {
				updateSubMenuAndParentMenu('payroll-status');
				break;
			}
			case `/payroll/status/${locationsplit1?.[3]}`: {
				updateSubMenuAndParentMenu('payroll-status');
				break;
			}
			case `/payroll/failedDetail/${locationsplit1?.[3]}`: {
				updateSubMenuAndParentMenu('payroll-status');
				break;
			}
			case '/payroll/proof_of_transfer': {
				updateSubMenuAndParentMenu('proof-of-funds-transfer');
				break;
			}
			case '/payroll/timings': {
				updateSubMenuAndParentMenu('payroll-timings');
				break;
			}
			case '/payroll/approve_requests': {
				updateSubMenuAndParentMenu('payroll-approve-requests');
				break;
			}
			case '/payroll/wps_table': {
				updateSubMenuAndParentMenu('payroll-approve-requests');
				break;
			}
			case '/payroll/bank_details': {
				updateSubMenuAndParentMenu('our-bank-details');
				break;
			}
			case '/salary': {
				updateSubMenuAndParentMenu('salary-reports');
				break;
			}
			case '/salary/salary_per_employee': {
				updateSubMenuAndParentMenu('salary-reports');
				break;
			}
			case '/salary-history': {
				updateSubMenuAndParentMenu('salary-reports');
				break;
			}
			case '/salary-monthwise_reports': {
				updateSubMenuAndParentMenu('salary-reports');
				break;
			}
			case '/payroll/useful_files': {
				break;
			}
			case '/employees/manage_employee': {
				updateSubMenuAndParentMenu('manage-employees');
				break;
			}
			case '/employees/replacement_card': {
				updateSubMenuAndParentMenu('manage-employees');
				break;
			}
			case '/employees/add/multiple/employees/upload': {
				updateSubMenuAndParentMenu('manage-employees');
				break;
			}
			case '/employee/update': {
				updateSubMenuAndParentMenu('manage-employees');
				break;
			}
			case '/employees/add/multiple/employees/submit': {
				updateSubMenuAndParentMenu('manage-employees');
				break;
			}
			case '/employees/add/multiple/employees/submit/nextsteps': {
				updateSubMenuAndParentMenu('manage-employees');
				break;
			}
			case '/employees/transaction-detail': {
				updateSubMenuAndParentMenu('manage-employees');
				break;
			}
			case '/employees/requestStatement': {
				updateSubMenuAndParentMenu('manage-employees');
				break;
			}
			case '/employees/viewemployee': {
				updateSubMenuAndParentMenu('manage-employees');
				break;
			}
			case '/manange/employees/bulk/delete': {
				updateSubMenuAndParentMenu('manage-employees');
				break;
			}
			case '/cardholder': {
				updateSubMenuAndParentMenu('manage-employees');
				break;
			}
			case '/cardholder/c3paynumber': {
				updateSubMenuAndParentMenu('manage-employees');
				break;
			}
			case '/cardholder/banknumber': {
				updateSubMenuAndParentMenu('manage-employees');
				break;
			}
			case '/employees/card/order/track/status': {
				updateSubMenuAndParentMenu('card-order-status');
				break;
			}
			case '/employees/card/order/view/details': {
				updateSubMenuAndParentMenu('card-order-status');
				break;
			}
			case '/employees/card/order/status': {
				updateSubMenuAndParentMenu('card-order-status');
				break;
			}
			case '/employees/card-request-detail': {
				updateSubMenuAndParentMenu('employees-approve-requests');
				break;
			}
			case '/employees/approve_employee_request': {
				updateSubMenuAndParentMenu('employees-approve-requests');
				break;
			}
			case '/company/company-setting': {
				updateSubMenuAndParentMenu('company-setting');
				break;
			}
			case '/manage_team': {
				updateSubMenuAndParentMenu('team-permissions');
				break;
			}
			case `/user_role/${locationsplit1?.[2]}`: {
				updateSubMenuAndParentMenu('team-permissions');
				break;
			}
			case '/invite_team_member': {
				updateSubMenuAndParentMenu('team-permissions');
				break;
			}
			case '/permission/user': {
				updateSubMenuAndParentMenu('team-permissions');
				break;
			}
			case '/company/information': {
				updateSubMenuAndParentMenu('company-information');
				break;
			}
			case '/company/upload-spreadsheet': {
				updateSubMenuAndParentMenu('company-information');
				break;
			}
			case '/leaves/leaves_to_approve': {
				updateSubMenuAndParentMenu('leavestoapprove');
				break;
			}
			case '/leaves/leaves_statuses': {
				updateSubMenuAndParentMenu('leavestatues');
				break;
			}
			case '/leaves/request_leave': {
				updateSubMenuAndParentMenu('requestleave');
				break;
			}
			case '/approval-workflow-leave': {
				updateSubMenuAndParentMenu('approvalworkflow');
				break;
			}
			case '/hrdocuments': {
				updateMenuAndFirstSubMenu('documents');
				break;
			}
			case '/documents/document-setup': {
				updateMenuAndFirstSubMenu('documents');
				break;
			}
			case '/documents/documents-upload': {
				updateMenuAndFirstSubMenu('documents');
				break;
			}
			case '/documents/preview-upload-document': {
				updateMenuAndFirstSubMenu('documents');
				break;
			}
			case '/announcement': {
				updateMenuAndFirstSubMenu('announcements');
				break;
			}
			case '/new-hr-features/announcement': {
				updateMenuAndFirstSubMenu('announcements');
				break;
			}
			case '/payslip': {
				updateMenuAndFirstSubMenu('payslip');
				break;
			}
			case '/design-system': {
				updateMenuAndFirstSubMenu('design-system');
				break;
			}
			case '/employees/useful/files': {
				updateMenuAndFirstSubMenu('usefulFiles');
				break;
			}
			case '/proof-of-invoice': {
				updateMenuAndFirstSubMenu('invoice');
				break;
			}
			case '/proof-of-invoice/history': {
				updateMenuAndFirstSubMenu('invoice');
				break;
			}
			case '/videoTutorial': {
				updateMenuAndFirstSubMenu('video-tutorials');
				break;
			}
			case '/help': {
				updateMenuAndFirstSubMenu('help');
				break;
			}
			case '/leads': {
				updateMenuAndFirstSubMenu('logout');
				break;
			}

			case '/un-employment-insurance/employee':
			case '/un-employment-insurance/plan':
			case '/un-employment-insurance/terms-and-conditions':
			case '/un-employment-insurance/bulk-update':
			case '/un-employment-insurance/single-update':
			case '/un-employment-insurance/success': {
				updateMenuAndFirstSubMenu('un-employment-insurance');
				break;
			}
			default:
				break;
		}
	};

	useEffect(() => {
		const handleResize = () => {
			const width = window.innerWidth;

			if (width <= 1300) {
				setSize(true);
			} else {
				setSize(false);
			}
		};

		window.addEventListener('resize', handleResize);

		window.onresize = handleResize();
	}, []);

	useEffect(() => {
		updateMenusBasedOnRoute();
	}, [menus]);

	useEffect(() => {
		updateMenusBasedOnRoute();
	}, [location]);
}

export default useSideEffects;
